import {
  createFormState,
  getPaymentStartByType,
  getPaymentConfirmByType,
  getPaymentSummaryByType,
} from "@/utils";
import { PAYMENT_FORMS, mobilePaymentFields, webPaymentFields } from "@/config";
import axios from "axios";

// Default state
const defaultState = () => {
  return {
    // Toggles
    error: null,
    isErrorAfterPaying: false,
    summaryIsLoading: false,
    submitPaymentIsLoading: false,
    confirmPaymentIsLoading: false,

    // Data
    orderSummary: null,
    paymentData: null,

    // Forms
    [PAYMENT_FORMS.mobile]: createFormState(mobilePaymentFields),
    [PAYMENT_FORMS.web]: createFormState(webPaymentFields),
    [PAYMENT_FORMS.therapistClient]: createFormState(webPaymentFields),
  };
};

// State object
const state = defaultState();

// Getter functions
const getters = {
  getPaymentIsLoading: (state) => {
    return state.submitPaymentIsLoading;
  },
  getIsErrorAfterPaying: (state) => {
    return state.isErrorAfterPaying;
  },
  getPaymentSummaryIsLoading: (state) => {
    return state.summaryIsLoading;
  },
  getOrderSummary: (state) => {
    return state.orderSummary;
  },
  getPaymentForm: (state) => (keyword) => {
    return state[keyword];
  },
  getPaymentError(state) {
    return state.error;
  },
};

// Actions
const actions = {
  async getSaleSummaryAction({ commit }, payload) {
    const endpoint = getPaymentSummaryByType(payload.paymentType);
    const formData = new FormData();

    delete payload.paymentType;

    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    commit("SET_PAYMENT_SUMMARY_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoint, payload)
        .then((response) => {
          commit("SET_PAYMENT_SUMMARY_IS_LOADING", false);
          commit("SET_ORDER_SUMMARY", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("SET_PAYMENT_SUMMARY_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  async submitPayment({ commit }, payload) {
    const endpoint = getPaymentStartByType(payload.paymentType);
    const formData = new FormData();

    delete payload.paymentType;

    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    commit("SET_SUBMIT_PAYMENT_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoint, formData)
        .then((response) => {
          commit("SET_SUBMIT_PAYMENT_IS_LOADING", false);
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("SET_SUBMIT_PAYMENT_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  async confirmPayment({ commit }, payload) {
    const endpoint = getPaymentConfirmByType(payload.paymentType);
    const formData = new FormData();

    delete payload.paymentType;

    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    commit("SET_CONFIRM_PAYMENT_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoint, formData)
        .then((response) => {
          commit("SET_CONFIRM_PAYMENT_IS_LOADING", false);
          commit("SET_SUBMIT_PAYMENT_DATA", response.data);

          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);

            if (error.response.data?.paid) {
              commit("SET_IS_ERROR_AFTER_PAYING", true);
            }
          }

          commit("SET_CONFIRM_PAYMENT_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  setFormData({ commit }, data) {
    commit("SET_FORM_DATA", data);
  },
  resetFormData({ commit }, formName) {
    commit("RESET_FORM_DATA", formName);
  },
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};

// Mutations
const mutations = {
  SET_PAYMENT_SUMMARY_IS_LOADING(state, isLoading) {
    state.summaryIsLoading = isLoading;
  },
  SET_CONFIRM_PAYMENT_IS_LOADING(state, isLoading) {
    state.confirmPaymentIsLoading = isLoading;
  },
  SET_IS_ERROR_AFTER_PAYING(state, isErrorAfterPaying) {
    state.isErrorAfterPaying = isErrorAfterPaying;
  },
  SET_SUBMIT_PAYMENT_DATA(state, data) {
    state.paymentData = data;
  },
  SET_SUBMIT_PAYMENT_IS_LOADING(state, isLoading) {
    state.submitPaymentIsLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_ORDER_SUMMARY(state, orderSummary) {
    state.orderSummary = orderSummary;
  },
  SET_FORM_DATA(state, { formName, field, value, touched }) {
    state[formName][field].value = value;
    state[formName][field].touched = touched;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  name: "PaymentModule",
  dynamic: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
